import axios, { isCancel } from '../axios';

export const register = async data => {
  try {
    const res = await axios.post('auth/register', data);
    return res;
  } catch (error) {
    if (isCancel(error)) {
      console.log('Request cancelled...');
      return;
    } else {
      throw error;
    }
  }
};

export const login = async data => {
  try {
    const res = await axios.post('auth/login', data, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
    return res;
  } catch (error) {
    if (isCancel(error)) {
      console.log('Request cancelled...');
      return;
    } else {
      throw error;
    }
  }
};

export const logout = async () => {
  try {
    const res = await axios.post('auth/logout');
    return res;
  } catch (error) {
    if (isCancel(error)) {
      console.log('Request cancelled...');
      return;
    } else {
      throw error;
    }
  }
};
